
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nonprofits/get-started/[nonprofitSlug]",
      function () {
        return require("private-next-pages/nonprofits/get-started/[nonprofitSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nonprofits/get-started/[nonprofitSlug]"])
      });
    }
  